import React, { Component } from 'react';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import Wrap from "./wrap";
// 路由配置
//首页
import Index from "pages/index";
//面试结果
import Result from "pages/result";
import MobileResult from "pages/mobileResult";
// ai面试结果分析
import AnalysisReport from "pages/analysisReport";
//视频面试pc端
import VideoCheck from "pages/check";
import Record from "pages/record";
import SuggestVideo from "pages/suggest";
//登录
import Login from "pages/login";
//视频流水页
import List from "pages/list";
//快捷创建账号
import CreateAccount from "pages/createAccount";
import Bind from "pages/bind";
//ATS 增加human报告消费流水展示页
import ReportFlow from "pages/manager/reportFlow";
//兼容双向视频点击小程序链接，打开二维码页面
import Oivib from "pages/oivib";
// ai面试移动端打开提示
import MobileTips from "pages/mobileTips";
//公用样式
import "styles/iconfont/iconfont.css";
import 'styles/common.less';

function Routers(props){
    return (
        <Router>
            <Wrap>
                <Switch>
                    <Route exact path="/" component={ Index } />
                    <Route exact path="/index" component={ Index } />
                    {/* <Route exact path="/console/login" component={ Login } /> */}
                    {/* <Route exact path="/console/list" component={ List } /> */}
                    <Route exact path="/create" component={ CreateAccount } />
                    <Route exact path="/bind" component={ Bind } />
                    <Route exact path="/result" component={ Result } />
                    <Route exact path="/result/mobile" component={ MobileResult } />
                    <Route path="/check" component={ VideoCheck } />
                    <Route path="/record" component={ Record } />
                    <Route path="/suggest" component={ SuggestVideo } />
                    <Route exact path="/reportFlow" component={ ReportFlow } />
                    <Route exact path="/oivib" component={ Oivib } />
                    <Route exact path="/aiReport" component={ AnalysisReport }/>
                    <Route exact path="/aiIndex" component={ MobileTips }/>
                </Switch>
            </Wrap>
        </Router>
    )
}

export default Routers;
